import update from 'immutability-helper';
import calcWin from 'Util/calcWin';

export const placeSquare = (xl, yl, xs, ys) => ({
  type: 'PLACE_SQUARE',
  large: [xl, yl],
  small: [xs, ys]
})

// Game mode: the type of game
// Local players, the local players playing, defaults to ['x', 'y']
export const startGame = (gamemode, localPlayers=['x', 'y']) => {
  return {
    type: 'START_GAME',
    gamemode,
    localPlayers
  }
}

export const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'START_GAME':
    // (3x3)x(3x3) grid
    // (large) x (small)
    state = {
      winner: '',
      active: null,
      player: 'x',
      turnNumber: 0,
      waitingOnRemote: !action.localPlayers.includes('x'),
      localPlayers: action.localPlayers,
      gamemode: action.gamemode,
      board: new Array(3).fill(null).map(() => {
        return new Array(3).fill(null).map(() => {
          return {
            winner: '',
            board: new Array(3).fill(null).map(() => { return new Array(3).fill('') })
          }
        })
      })
    }

    return state;

    case 'PLACE_SQUARE':
      // TODO: TIDY
      const { large, small } = action;
      const player = state.player;

      const micro = update(state.board[large[0]][large[1]], {
        board: {
          [small[0]]: {
            [small[1]]: {
              $set: player
            }
          }
        }
      });

      const microWinner = calcWin(micro.board);

      let shouldCheckMacro = false;
      // A square has been won so we should check macro
      if(microWinner !== micro.winner) {
        micro.winner = microWinner;
        // We have to wait to check macro until the update has happened which can only occur after this
        shouldCheckMacro = true
      }

      const nextPlayer = state.player === 'x'? 'o': 'x';

      const newState = update(state, {
        board: {
          [large[0]]: {
            [large[1]]: {
              $set: micro
            }
          }
        },
        player: {
          $set: nextPlayer
        },
        waitingOnRemote: {
          // If the local players doesn't include the next player then it must be remote
          $set: !state.localPlayers.includes(nextPlayer)
        },
        turnNumber: {
          $set: state.turnNumber + 1
        }
      });

      // If square is already won then all valid squares are active otherwise just small coordinates as per rules of uttt.
      const active = newState.board[small[0]][small[1]].winner === ''? [small[0], small[1]]: null;
      newState.active = active;

      if(shouldCheckMacro) {
        const macroWinner = calcWin(newState.board.map(row => {
          return row.map(square => square.winner)
        }));

        if (macroWinner !== '') {
          newState.winner = macroWinner;
        }
      }

      return newState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/Game/State/index.js